const roles = [
  {
    badge: 'Dono',
    title: 'Controle total',
    desc: 'Acesso completo ao dashboard, configurações, financeiro, equipe e site do restaurante.',
  },
  {
    badge: 'Gerente',
    title: 'Operação do dia a dia',
    desc: 'Gerencia pedidos, mesas e equipe. Não acessa configurações financeiras ou do site.',
  },
  {
    badge: 'Operador',
    title: 'Painel de pedidos',
    desc: 'Visualiza e atualiza status de pedidos e mesas. Ideal para garçons e cozinheiros.',
  },
]

export default function TeamSection() {
  return (
    <section className="bg-white px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24">
      <div className="max-w-[1140px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-neutral-400 mb-3">
          Equipe
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.1] mb-4">
          Para toda a equipe.
        </h2>
        <p className="text-base lg:text-[17px] text-neutral-500 leading-[1.7] max-w-[520px]">
          Adicione garçons, gerentes e cozinheiros com permissões diferentes. Cada um vê só o que precisa.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5 mt-10 lg:mt-16">
          {roles.map((role) => (
            <div key={role.badge} className="bg-neutral-50 border border-neutral-200 rounded-2xl p-6">
              <span className="inline-block text-[11px] font-bold px-2.5 py-[3px] rounded-full mb-3 bg-black text-white">
                {role.badge}
              </span>
              <h3 className="text-[15px] font-bold mb-2">{role.title}</h3>
              <p className="text-sm text-neutral-500 leading-[1.55]">{role.desc}</p>
            </div>
          ))}
        </div>

        {/* Seats callout */}
        <div className="mt-6 border rounded-2xl p-6 lg:p-8 flex flex-col sm:flex-row sm:items-center gap-5" style={{ background: '#FAFAF8', borderColor: '#ebebeb' }}>
          <div className="flex-1">
            <p className="text-[15px] font-bold text-black mb-1">
              Ilimitadas pessoas no mesmo painel.
            </p>
            <p className="text-[13px] text-neutral-500 leading-[1.6]">
              Garçons, cozinheiros e gerentes — cada um com o acesso certo. Tudo incluso no plano por <strong className="text-black">R$149/mês</strong>.
            </p>
          </div>
          <a
            href="#testar-gratis"
            className="flex-shrink-0 flex items-center justify-center no-underline px-6 py-3.5 rounded-full text-[13px] font-bold transition-colors whitespace-nowrap"
            style={{ background: '#141410', color: 'white' }}
          >
            Começar 30 dias grátis →
          </a>
        </div>
      </div>
    </section>
  )
}
